import axios, { AxiosRequestConfig } from 'axios';
import { MESSAGES } from '../CommonConstants';
import { ApiError } from '../errors/ApiError';
import {
  addCobrowsingFlagToInput,
  addOrionUserIdToInput,
  addPreviewFlagToInput,
} from './fetchWithDefaults';
import { getHeadersOptions } from './getHeaderOptions';

const sidToken = sessionStorage.getItem('sid');

const headerOptions = getHeadersOptions();

export const API = axios.create({
  headers: {
    ...(sidToken ? { 'X-Adv-Sid': sidToken } : {}),
    ...(headerOptions.xsrf ? { 'x-xsrf-token': headerOptions.xsrf } : {}),
    ...(headerOptions.authorization ? { Authorization: headerOptions.authorization } : {}),
    'X-Requested-With': 'XMLHttpRequest',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
});

interface RequestConfig extends AxiosRequestConfig {
  extendSession?: boolean;
}

API.interceptors.request.use((config: RequestConfig) => {
  if (config.extendSession) {
    ADV.util.SessionTimeout.extendTimer();
  }

  return {
    ...config,
    url: config.url
      ? addPreviewFlagToInput(addOrionUserIdToInput(addCobrowsingFlagToInput(config.url)))
      : config.url,
  };
});

API.interceptors.response.use(response => {
  switch (response.status) {
    case 401:
      if (
        ADV.util.env('isAdviserArea') &&
        response.headers.get('X-Adv-Reason') === 'License in use'
      ) {
        window.ADV.adviser.showMultipleSessionWarningModal();
        return response;
      }

      ADV.Controller.logout(false, true);

      break;

    case 402:
      if (ADV.util.Router.status().id !== 'Checkout') {
        ADV.util.Router.go2('Checkout');
        return response;
      }
      break;

    case 503:
      window.location.href = '/Maintenance';
      break;
    default:
  }

  if (response.headers['X-Slided'] === '1') {
    ADV.util.SessionTimeout.extendTimer();
  }

  const sidRenewToken = response.headers['X-Adv-Sid-Renew'];
  const xsrfRenewToken = response.headers['X-Xsrf-Token-Renew'];

  if (sidRenewToken) {
    sessionStorage.setItem('sid', sidRenewToken);
  }
  if (xsrfRenewToken) {
    sessionStorage.setItem('xsrf', xsrfRenewToken);
  }

  const {
    data: { success, errors, payload },
  } = response;

  if (!success) {
    if (errors) {
      throw new ApiError(errors[0]);
    }
    throw new Error(MESSAGES.GENERIC_ERROR);
  }

  return payload.viewData;
});
